$(document).ready(function () {
  // Open/Hide customer menu on desktop
  $('.header_account').bind({
    mouseover: function() {
      $('.account_box_wrap').show();
    },
    mouseout: function() {
      $('.account_box_wrap').hide();
    }
  });

  // Open/Hide customer menu on mobile
  $('[data-responsive-id="header-account-mobile"]').on('click', function() {
    $('#menu-account-mobile').addClass('on');
    $('body').css('overflow', 'hidden');
  });
  $('#menu-account-mobile .menu-account-mobile-close, #menu-account-mobile .menu-account li a').on('click', function() {
    $('#menu-account-mobile').removeClass('on');
    $('body').css('overflow', '');
  });
  $('#menu-account-mobile').on('click', function(e) {
    console.log($('#menu-account-content-mobile').offset().left);
    if (e.offsetX < $('#menu-account-content-mobile').offset().left) {
      $('#menu-account-mobile').removeClass('on');
    } 
  });

  // Update cart when quantity change
  $('.quantity_modifier').not('.disabled').on('click', function(e) {
    let btn = $(this),
        inputQty = $(this).prev('input.quantity_input_cart_page'),
        qtyValue = parseInt(inputQty.val()) + 1,
        qtyMax = parseInt(inputQty.attr('max'));
    if(btn.hasClass('quantity_up') && qtyValue > qtyMax) {
      setTimeout(function() {
        inputQty.val(qtyMax);
      }, 100);
    } else {
      setTimeout(function(){
        $('#formCart').submit();
      }, 500);
    }
  });

});

$(window).scroll(function () {
  if($(this).scrollTop() > 150){
    $('.product-add-to-cart-wrapper.sticky').addClass('on');
  }else{
    $('.product-add-to-cart-wrapper.sticky').removeClass('on');
  }
});

$(window).load(function() {
  // Open first block footer on mobile
  var wscreen = $(window).width();
  if(wscreen < 768) {
    $('.toggle-mobile').first().click();
  }
});

function updateCart() {
  let form = document.getElementById('formCart');
  form.action='cart/update.js';
  form.submit();
}
